// extracted by mini-css-extract-plugin
module.exports = {"grid":"OrderGrid_grid__21-AL","actionsGroup":"OrderGrid_actionsGroup__9CrMh","contextActions":"OrderGrid_contextActions__3OYJd"};